const REQUIRED_FIELDS = [
  'name',
  'price',
  'birth_year',
  'breeds',
  'color',
  'gender',
  'height',
  'temperament',
];
const SCORE_COMPONENTS = {
  REQUIRED: 40,
  DISCIPLINES: 10,
  DESCRIPTION: 10,
  BBP: 5,
  IMAGES: 20,
  VIDEOS: 15
};
const TARGET_DESCRIPTION_LENGTH = 650;
const TARGET_IMAGES = 8;

const total = (scores) => _.sum(_.map(scores, (rawScore, component) => SCORE_COMPONENTS[component] * rawScore));

const present = (value) => !_.isEmpty(value) || _.isNumber(value);

function requiredScore(listing) {
  const requiredPresent = REQUIRED_FIELDS.filter((field) => present(listing[field])).length;
  return requiredPresent / REQUIRED_FIELDS.length;
}
function disciplinesScore(listing) {
  const hasDisciplines = listing.disciplines?.length > 0;
  return hasDisciplines ? 1 : 0;
}
function descriptionScore(listing) {
  const descriptionPercent = (listing.description?.length ?? 0) / TARGET_DESCRIPTION_LENGTH;
  return Math.min(descriptionPercent, 1);
}
function bbpScore(listing) {
  const bbpDone = listing.has_behavior_profile && listing.behavior_profile?.evaluator_name && listing.behavior_profile?.evaluation_date;
  return bbpDone ? 1 : 0;
}
function imageScore(listing) {
  const imageCount = listing.images?.length || 0;
  return Math.max(Math.min(Math.log10(1 + imageCount / TARGET_IMAGES * 9), 1), 0);
}
function videoScore(listing) {
  const videoCount = listing.videos?.length || 0;
  return Math.min(videoCount, 1);
}

export function listingScores(listing) {
  return {
    REQUIRED: requiredScore(listing),
    DISCIPLINES: disciplinesScore(listing),
    DESCRIPTION: descriptionScore(listing),
    BBP: bbpScore(listing),
    IMAGES: imageScore(listing),
    VIDEOS: videoScore(listing),
  };
}

export const totalScore = (scores) => _.clamp(Math.round(total(scores)), 0, 100);

export const qualityRating = (listing, score) => {
  if (score > 80) return 'good';
  if (score > 60) return 'ok';
  if (listing.status === 'published') return 'bad';
  return "";
}
export const suggestion = (scores) => {
  if (scores.REQUIRED < 1) return "Complete all fields on the General Info tab to improve your score";
  if (scores.DISCIPLINES < 1) return "List the disciplines that fit your equine to improve your score";
  if (scores.IMAGES < 0.55) return "Add photos to improve your score";
  if (scores.DESCRIPTION < 0.65) return "Add detail to your description to improve your score";
  if (scores.VIDEOS < 0.65) return "Add videos to improve your score";
  if (scores.IMAGES < 0.75) return "Add photos to improve your score";
  if (scores.BBP < 1) return "A Basic Behavioral Profile will help improve your score";
  return "Good Job!";
}
